import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientParticipantComponent } from '../portal/clients/client-participant/client-participant.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { AgmCoreModule } from '@agm/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { CalendarModule } from 'angular-calendar';
import { FileUploadModule } from 'ng2-file-upload';
import { LoadingModule } from 'ngx-loading';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PipesModule } from '../core/pipes/pipes.module';
import { NotesService } from './notes/notes.service';
import { StateProvinceService } from './state-province/state-province.service';
import { BorderConnectionService } from './border/border-connection.service';
import { NoticeComponent } from './notes/notice/notice.component';
import { NoteSideBarComponent } from './notes/note-side-bar/note-side-bar.component';
import { DocumentUploaderService } from './documents/document-uploader.service';
import { CompanyStatusService } from './company/company-status.service';
import { AnsoniaService } from './ansonia/ansonia.service';
import { GuardConfirmComponent } from './guard/guard-confirm/guard-confirm.component';
import { CalculatorComponent } from './calculator/calculator.component';
import { MessageBoardService } from './message-board/message-board.service';
import { DocuSignService } from './docusign/docusign.service';
import { IndustryService } from './industry/industry.service';
import { WorkflowDetailService } from './workflow/workflow-detail.service';
import { WorkflowDetailTaskService } from './workflow/workflow-detail-task.service';
import { InternalScoringService } from '../portal/internal-scoring/internal-scoring.service';
import { QueueService } from './notifications/queue.service';
import { FrequencyService } from './notifications/frequency.service';
import { NotificationQueueComponent } from './notifications/notification-queue/notification-queue.component';
import { NotificationQueueContentModalComponent } from './notifications/notification-queue/notification-queue-content-modal/notification-queue-content-modal.component';
import { CanadaStatePipe } from './pipes/canada-state.pipe';
import { DashPipe } from './pipes/dash-pipe.pipe';
import { DisplayGradePipe } from './pipes/display-grade.pipe';
import { CommonService } from './common/common.service';
import { ServiceSubscriptionService } from '../fleet-manager/company/components/companydetails/options/company-services-options/service-subscription.service';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    RouterModule,
    // BrowserAnimationsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDe_oVpi9eRSN99G4o6TwVjJbFBNr58NxE'
    }),
    CalendarModule.forRoot(),
    PerfectScrollbarModule,
    MultiselectDropdownModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    NgxChartsModule,
    PipesModule,
    LoadingModule,
    FileUploadModule,
    NgxDatatableModule,
  ],
  declarations: [
    ClientParticipantComponent,
    NoticeComponent,
    NoteSideBarComponent,
    GuardConfirmComponent,
    CalculatorComponent,
    NotificationQueueComponent,
    NotificationQueueContentModalComponent,
    CanadaStatePipe,
    DashPipe,
    DisplayGradePipe
  ],
  exports: [
    ClientParticipantComponent,
    NoticeComponent,
    NoteSideBarComponent,
    CalculatorComponent,
    NotificationQueueComponent,
    NotificationQueueContentModalComponent,
    CanadaStatePipe,
    DashPipe,
    DisplayGradePipe
  ],
  providers: [
    NotesService,
    BorderConnectionService,
    DocumentUploaderService,
    CompanyStatusService,
    StateProvinceService,
    AnsoniaService,
    MessageBoardService,
    DocuSignService,
    IndustryService,
    InternalScoringService,
    CommonService,
    QueueService,
    FrequencyService,
    ServiceSubscriptionService,
    WorkflowDetailService,
    WorkflowDetailTaskService,
  ],
  entryComponents: [
    GuardConfirmComponent,
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts